import presentation from './presentation-policy.json' with {type:'json'};

// Recognize the existing, standalone reading-order instruction in each edition.
// This also repairs presentation of older cached books without changing their
// words, block IDs, or the location of the instruction within the chapter.
const normalize=text=>text.normalize('NFKC').replace(/[\s!¡。.：:]/gu,'').toUpperCase();
const warnings=new Set(presentation.warnings.map(normalize));

export function chapterWarnings(html){
  return html.replace(/<(p|h[2-6])\b([^>]*)>([\s\S]*?)<\/\1\s*>/gi,(original,tag,attributes,content)=>{
    if(content.includes('chapter-order-warning'))return original;
    const text=content.replace(/<[^>]*>/g,'');
    if(!warnings.has(normalize(text)))return original;
    return `<${tag}${attributes}><strong class="chapter-order-warning">${content}</strong></${tag}>`;
  });
}
